import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store';

import { OfflineBehavior } from './model';

export const value = (state: RootState) => state.settings.value;
export const request = (state: RootState) => state.settings.request;

export const isLoaded = createSelector(value, (v) => Boolean(v));
export const isLoading = createSelector(request, (r) => r === 'loading');
export const isError = createSelector(request, (r) => r === 'error');
export const neverLoaded = createSelector(
  value,
  request,
  (v, r) => v === null && r === 'idle',
);

export const assistantOnline = createSelector(value, (v) => v?.assistantOnline);

export const widgetSettings = createSelector(value, (v) => v?.widgetSettings);

export const offlineStrategy = createSelector(
  widgetSettings,
  (settings) => settings?.offlineBehavior,
);

export const offlineStrategyIsChat = createSelector(
  offlineStrategy,
  (s) => s === OfflineBehavior.CHAT_ONLY,
);

export const introMessageSettings = createSelector(
  value,
  (v) => v?.widgetSettings?.introMessage?.message,
);

export const legalMessageSettings = createSelector(
  value,
  (v) => v?.widgetSettings?.introMessage?.legalDisclaimer,
);

export const engageMessageSettings = createSelector(
  value,
  (v) => v?.widgetSettings?.introMessage?.engage,
);

export const offlineMessageSettings = createSelector(
  value,
  (v) => v?.widgetSettings?.introMessage?.offlineDisclaimer,
);

export const suggestionsSettings = createSelector(
  value,
  (v) => v?.widgetSettings?.introMessage?.suggestions,
);

export const contactFormFields = createSelector(
  value,
  (v) => v?.widgetSettings?.contactForm?.fields,
);

export const isReportingEnabled = createSelector(value, (v) =>
  Boolean(v?.widgetSettings?.navigationSummary),
);

export const avatar = createSelector(value, (v) => v?.widgetSettings?.avatar);
